import { STAKEHOLDER_TYPE_ID_DRIVER, STAKEHOLDER_TYPE_ID_LEASING_COMPANY } from "@/shared/domain/insuredGood";

export const hasStakeholders = (details: MyBrokerApi.Vehicle): boolean => {
    return details.stakeHoldersList && details.stakeHoldersList.length > 0;
};

export const getMainDriver = (details: MyBrokerApi.Vehicle): MyBrokerApi.StakeHolder | null => {
    return (
        (hasStakeholders(details) && details.stakeHoldersList.find((driver) => driver.isMainDriver === true)) || null
    );
};

export const getAdditionalDrivers = (details: MyBrokerApi.Vehicle): MyBrokerApi.StakeHolder[] | null => {
    return (
        (hasStakeholders(details) &&
            details.stakeHoldersList.filter(
                (driver) => driver.isMainDriver !== true && driver.type.id === STAKEHOLDER_TYPE_ID_DRIVER,
            )) ||
        null
    );
};

export const getLeasingCompany = (details: MyBrokerApi.Vehicle): MyBrokerApi.StakeHolder | null => {
    return (
        (hasStakeholders(details) &&
            details.stakeHoldersList.find(
                (driver) => driver.isMainDriver !== true && driver.type.id === STAKEHOLDER_TYPE_ID_LEASING_COMPANY,
            )) ||
        null
    );
};
